var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alpheios-navbuttons alpheios-navbuttons--large" },
    [
      _c(
        "alph-tooltip",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.$store.state.ui.overrideHelp,
              expression: "! $store.state.ui.overrideHelp",
            },
          ],
          attrs: {
            tooltipText: _vm.l10n.getText("TOOLTIP_HELP"),
            tooltipDirection: "bottom-narrow",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "alpheios-navbuttons__btn",
              class: { active: _vm.$store.getters["ui/isActiveTab"]("info") },
              attrs: { id: "alpheios-panel-navbuttons-info" },
              on: {
                click: function ($event) {
                  return _vm.ui.changeTab("info")
                },
              },
            },
            [_c("help-icon")],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "alph-tooltip",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$store.getters["app/fullDefDataReady"],
              expression: "$store.getters['app/fullDefDataReady']",
            },
          ],
          attrs: {
            tooltipText: _vm.l10n.getText("TOOLTIP_SHOW_DEFINITIONS"),
            tooltipDirection: "bottom-narrow",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "alpheios-navbuttons__btn",
              class: {
                active: _vm.$store.getters["ui/isActiveTab"]("definitions"),
              },
              attrs: { id: "alpheios-panel-navbuttons-definitions" },
              on: {
                click: function ($event) {
                  return _vm.ui.changeTab("definitions")
                },
              },
            },
            [_c("definitions-icon")],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "alph-tooltip",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$store.state.app.hasInflData,
              expression: "$store.state.app.hasInflData",
            },
          ],
          attrs: {
            tooltipText: _vm.l10n.getText("TOOLTIP_SHOW_INFLECTIONS"),
            tooltipDirection: "bottom-narrow",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "alpheios-navbuttons__btn",
              class: {
                active: _vm.$store.getters["ui/isActiveTab"]("inflections"),
              },
              attrs: { id: "alpheios-panel-navbuttons-inflections" },
              on: {
                click: function ($event) {
                  return _vm.ui.changeTab("inflections")
                },
              },
            },
            [_c("inflections-icon")],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "alph-tooltip",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.$store.state.lexis.hasTreebankData &&
                !_vm.$store.state.lexis.suppressTree,
              expression:
                "$store.state.lexis.hasTreebankData && !$store.state.lexis.suppressTree",
            },
          ],
          attrs: {
            tooltipText: _vm.l10n.getText("TOOLTIP_TREEBANK"),
            tooltipDirection: "bottom-narrow",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "alpheios-navbuttons__btn",
              class: {
                active: _vm.$store.getters["ui/isActiveTab"]("treebank"),
              },
              attrs: { id: "alpheios-panel-navbuttons-treebank" },
              on: {
                click: function ($event) {
                  return _vm.ui.changeTab("treebank")
                },
              },
            },
            [_c("treebank-icon")],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "alph-tooltip",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$store.state.app.wordUsageExampleEnabled,
              expression: "$store.state.app.wordUsageExampleEnabled",
            },
          ],
          attrs: {
            tooltipText: _vm.l10n.getText("TOOLTIP_SHOW_USAGEEXAMPLES"),
            tooltipDirection: "bottom-narrow",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "alpheios-navbuttons__btn",
              class: {
                active: _vm.$store.getters["ui/isActiveTab"]("wordUsage"),
              },
              attrs: { id: "alpheios-panel-navbuttons-wordusage" },
              on: {
                click: function ($event) {
                  return _vm.ui.changeTab("wordUsage")
                },
              },
            },
            [_c("word-usage-icon")],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "alph-tooltip",
        {
          attrs: {
            tooltipText: _vm.l10n.getText("TOOLTIP_INFLECT_BROWSER"),
            tooltipDirection: "bottom-narrow",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "alpheios-navbuttons__btn",
              class: {
                active:
                  _vm.$store.getters["ui/isActiveTab"]("inflectionsbrowser"),
              },
              attrs: { id: "alpheios-panel-navbuttons-inflectionsbrowser" },
              on: {
                click: function ($event) {
                  return _vm.ui.changeTab("inflectionsbrowser")
                },
              },
            },
            [_c("inflections-browser-icon")],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "alph-tooltip",
        {
          attrs: {
            tooltipText: _vm.l10n.getText("TOOLTIP_GRAMMAR"),
            tooltipDirection: "bottom-narrow",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "alpheios-navbuttons__btn",
              class: {
                active: _vm.$store.getters["ui/isActiveTab"]("grammar"),
              },
              attrs: { id: "alpheios-panel-navbuttons-grammar" },
              on: {
                click: function ($event) {
                  return _vm.ui.changeTab("grammar")
                },
              },
            },
            [_c("grammar-icon")],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "alph-tooltip",
        {
          attrs: {
            tooltipText: _vm.l10n.getText("TOOLTIP_WORDLIST"),
            tooltipDirection: "bottom-narrow",
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: this.$store.state.app.hasWordListsData,
                  expression: "this.$store.state.app.hasWordListsData",
                },
              ],
              staticClass: "alpheios-navbuttons__btn",
              class: {
                active: _vm.$store.getters["ui/isActiveTab"]("wordlist"),
              },
              attrs: { id: "alpheios-panel-navbuttons-wordlist" },
              on: {
                click: function ($event) {
                  return _vm.ui.changeTab("wordlist")
                },
              },
            },
            [_c("wordlist-icon")],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "alph-tooltip",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$store.state.auth.enableLogin,
              expression: "$store.state.auth.enableLogin",
            },
          ],
          attrs: {
            tooltipText: _vm.l10n.getText("TOOLTIP_USER"),
            tooltipDirection: "bottom-narrow",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "alpheios-navbuttons__btn",
              class: { active: _vm.$store.getters["ui/isActiveTab"]("user") },
              attrs: { id: "alpheios-panel-navbuttons-user" },
              on: {
                click: function ($event) {
                  return _vm.ui.changeTab("user")
                },
              },
            },
            [_c("user-icon")],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "alph-tooltip",
        {
          attrs: {
            tooltipText: _vm.l10n.getText("TOOLTIP_OPTIONS"),
            tooltipDirection: "bottom-narrow",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "alpheios-navbuttons__btn",
              class: {
                active: _vm.$store.getters["ui/isActiveTab"]("options"),
              },
              attrs: { id: "alpheios-panel-navbuttons-options" },
              on: {
                click: function ($event) {
                  return _vm.ui.changeTab("options")
                },
              },
            },
            [_c("options-icon")],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "alph-tooltip",
        {
          attrs: {
            tooltipText: _vm.l10n.getText("TOOLTIP_STATUS"),
            tooltipDirection: "bottom-narrow",
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: this.settings.isInVerboseMode(),
                  expression: "this.settings.isInVerboseMode()",
                },
              ],
              staticClass: "alpheios-navbuttons__btn",
              class: { active: _vm.$store.getters["ui/isActiveTab"]("status") },
              attrs: { id: "alpheios-panel-navbuttons-status" },
              on: {
                click: function ($event) {
                  return _vm.ui.changeTab("status")
                },
              },
            },
            [_c("status-icon")],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }